import { connect } from 'react-redux';
import { StoreState } from '../../../../../reducers';

import Toggle from '../../../../../components/Editor/Thumbnails/Column/Toggle';

const mapStateToProps = (state: StoreState) => {
	const {
		editor: {
			thumbnails: { isDisplayed },
		},
	} = state;

	return {
		isOpened: isDisplayed,
	};
};

export default connect(mapStateToProps)(Toggle);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/Thumbnails/Column/Toggle/index.tsx